import {
	ERROR_LOCATION__CUSTOMIZATION_MODAL,
	ERROR_LOCATION__DRAG_AND_DROP,
	ERROR_LOCATION__GLOBAL_SHORTCUTS,
	ERROR_LOCATION__GLOBAL_SIDE_NAVIGATION,
	ERROR_LOCATION__GSN_MAIN_NAV_ITEM,
	ERROR_LOCATION__GSN_NAV_ITEM_ACTIONS,
} from '../../../constants';

import {
	customizationMessages,
	defaultMessages,
	dndMessages,
	shortcutsMessages,
	sideNavItemActionsMenuMessages,
	sideNavMainItemMessages,
	sideNavMessages,
} from './messages';

// Remove as part of https://hello.jira.atlassian.cloud/browse/NAVX-4866
export function getMessagesForLocation(location?: string): Record<string, any> {
	const [baseLocation, uuId] = location?.split('--') || [];

	switch (baseLocation) {
		case ERROR_LOCATION__CUSTOMIZATION_MODAL:
			return customizationMessages;
		// Not used!
		case ERROR_LOCATION__DRAG_AND_DROP:
			return dndMessages;
		case ERROR_LOCATION__GLOBAL_SHORTCUTS:
			return { ...shortcutsMessages, values: { uuId } };
		case ERROR_LOCATION__GLOBAL_SIDE_NAVIGATION:
			return sideNavMessages;
		case ERROR_LOCATION__GSN_NAV_ITEM_ACTIONS:
			return sideNavItemActionsMenuMessages;
		case ERROR_LOCATION__GSN_MAIN_NAV_ITEM:
			return { ...sideNavMainItemMessages, values: { uuId } };
		default:
			return defaultMessages;
	}
}
